module.exports = __webpack_public_path__ + "static/media/76.60019492.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/76.jpg
// module id = 1014
// module chunks = 0